import React, { useState, useEffect } from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { generateClient } from 'aws-amplify/data'
import { getUrl } from 'aws-amplify/storage'

import type { Schema } from '../../../amplify/data/resource'
import { Picture } from '../../utils/Type'

const client = generateClient<Schema>()

const PhotosPage = () => {
  const [pictureData, setPictureData] = useState<
    Schema['XinXinPicture']['type'][]
  >([])
  const [pictures, setPictures] = useState<Picture[]>([])

  const fetchPictures = async () => {
    const { data: items } = await client.models.XinXinPicture.list()
    setPictureData(items)
  }

  const convertDate = (dateStr: string) => {
    const date = new Date(dateStr)
    const formatted = `${date.getFullYear()} ${date.toLocaleString('en-US', { month: 'long' })} ${date.getDate()}`
    return formatted
  }

  useEffect(() => {
    fetchPictures()
  }, [])

  const getImageUrl = async (fileKey: string) => {
    try {
      const signedUrl = await getUrl({ path: fileKey })
      return signedUrl.url
    } catch (error) {
      console.error('Failed to get image:', error)
      return null
    }
  }

  useEffect(() => {
    if (pictureData) {
      const loadImages = async () => {
        try {
          const imagePromises = pictureData.map(async (picture) => {
            const url = await getImageUrl(picture.path ?? '')
            return {
              description: picture.description ?? '',
              date: picture.date ?? '',
              url: url?.href.toString() ?? ''
            }
          })

          const tmpPics = await Promise.all(imagePromises)

          const sortedPics = [...tmpPics].sort((a, b) => {
            const dateA = new Date(a.date)
            const dateB = new Date(b.date)

            return dateB.getTime() - dateA.getTime()
          })
          setPictures(sortedPics)
        } catch (error) {
          console.error('Error loading images:', error)
        }
      }

      loadImages()
    }
  }, [pictureData])

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #FFE0E9 0%, #FFC1CC 100%)',
        minHeight: '100vh',
        padding: 4
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: 4
        }}
      >
        <Typography variant="h2" fontFamily={'ZCOOL KuaiLe'} align="center">
          欢迎来到小甜馨网站
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {pictures.map((picture, index) => {
          return (
            <Grid size={{ sm: 12, md: 6, lg: 4 }} key={index}>
              <Paper
                elevation={3}
                sx={{
                  backgroundColor: '#ADD8E6',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: 2,
                    '&:hover': {
                      boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.3)'
                    }
                  }}
                >
                  <img
                    src={picture.url}
                    alt="Xin Xin picture"
                    style={{ width: '100%', height: 'auto' }}
                  />
                  <Typography
                    variant="h5"
                    fontFamily={'ZCOOL KuaiLe'}
                    sx={{ px: 2 }}
                  >
                    {convertDate(picture.date)}
                  </Typography>
                  <Typography
                    variant="h6"
                    fontFamily={'ZCOOL KuaiLe'}
                    sx={{ px: 2, pb: 2 }}
                  >
                    {picture.description}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

export default PhotosPage
